import React, { useState, useEffect } from 'react';
import userService from '../services/user';
import utils from '../utils/utils';
import { NavLink, Redirect } from "react-router-dom";

export default function Activate(props) {

    const [isActive, setIsActive] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [redirectTo, setRedirectTo] = useState(null);

    useEffect(() => {
        const token = utils.getUrlParam(window.location.href, 'token', '');
        if (!token || token.length !== 24) {
            setErrorMessage(`Invalid token provided.`);
            return;
        }

        userService.activateAccount(token)
            .then(result => {
                if (result.error) {
                    setErrorMessage(result.error);
                    return;
                }

                setErrorMessage('');
                setIsActive(true);
            });
    }, []);

    return (
        <>
            {redirectTo && <Redirect push to={redirectTo} />}
            <div className="container container-small">
                <h4 className="mt-50">Activate your account</h4>
                <div className="mt-50">
                    {errorMessage && <div className="text-danger">{errorMessage}</div>}
                    {
                        isActive &&
                        <h5 className="text-success">Your account is activated successfully! Please login and start using the application.</h5>
                    }
                </div>

                <div className="mt-50">
                    <NavLink to="/login">
                        Back to login
                    </NavLink>
                    <br />
                    <NavLink to="/signup">
                        Create new account
                    </NavLink>
                </div>
            </div>
        </>
    );
}